import { defineMessage, MessageDescriptor } from 'react-intl';

type Price = {
  monthly: number;
  cent?: number;
};

export type PricePackage = {
  key: string;
  min: number;
  max?: number;
  title: MessageDescriptor;
  subTitle?: MessageDescriptor;
  name: MessageDescriptor;
  description1: MessageDescriptor;
  description2: MessageDescriptor;
  price?: {
    euro: Price;
    dollar: Price;
  };
};

export const pricePackages: Record<string, PricePackage> = {
  starter: {
    key: 'starter',
    min: 0,
    max: 150,
    price: {
      euro: {
        monthly: 20.5,
      },
      dollar: {
        monthly: 22,
      },
    },

    title: defineMessage<MessageDescriptor>({
      defaultMessage: 'Starter: {currency}{annually} / month',
      id: 'off-the-shelve/pricing/option1/title',
    }),
    name: defineMessage<MessageDescriptor>({
      defaultMessage: 'Starter',
      id: 'off-the-shelve/pricing/option1/name/title',
    }),
    subTitle: defineMessage<MessageDescriptor>({
      defaultMessage: 'billed monthly - cancelable any time',
      id: 'off-the-shelve/pricing/option1/subtitle',
    }),
    description1: defineMessage<MessageDescriptor>({
      defaultMessage: '0 - 150 triggers per month',
      id: 'off-the-shelve/pricing/option1/description1',
    }),
    description2: defineMessage<MessageDescriptor>({
      defaultMessage: 'Low usage, high return.',
      id: 'off-the-shelve/pricing/option1/description2',
    }),
  },
  pro: {
    key: 'pro',
    min: 151,
    max: 500,
    price: {
      euro: {
        monthly: 35.5,
      },
      dollar: {
        monthly: 38,
      },
    },
    title: defineMessage<MessageDescriptor>({
      defaultMessage: 'Pro: {currency}{annually} / month',
      id: 'off-the-shelve/pricing/option2/title',
    }),
    subTitle: defineMessage<MessageDescriptor>({
      defaultMessage: 'billed monthly - cancelable any time',
      id: 'off-the-shelve/pricing/option2/subtitle',
    }),
    name: defineMessage<MessageDescriptor>({
      defaultMessage: 'Pro',
      id: 'off-the-shelve/pricing/option2/name/title',
    }),
    description1: defineMessage<MessageDescriptor>({
      defaultMessage: '150 to 500 triggers per month',
      id: 'off-the-shelve/pricing/option2/description1',
    }),
    description2: defineMessage<MessageDescriptor>({
      defaultMessage: 'Medium usage, bunch of work.',
      id: 'off-the-shelve/pricing/option2/description2',
    }),
  },
  heavy: {
    key: 'heavy',
    min: 501,
    max: 2000,
    price: {
      euro: {
        monthly: 66,
      },
      dollar: {
        monthly: 69,
      },
    },
    title: defineMessage<MessageDescriptor>({
      defaultMessage: 'Heavy: {currency}{annually} / month',
      id: 'off-the-shelve/pricing/option3/title',
    }),
    subTitle: defineMessage<MessageDescriptor>({
      defaultMessage: 'billed monthly - cancelable any time',
      id: 'off-the-shelve/pricing/option3/subtitle',
    }),
    name: defineMessage<MessageDescriptor>({
      defaultMessage: 'Expert',
      id: 'off-the-shelve/pricing/option3/name/title',
    }),
    description1: defineMessage<MessageDescriptor>({
      defaultMessage: '500 - 2000 triggers per month',
      id: 'off-the-shelve/pricing/option3/description1',
    }),
    description2: defineMessage<MessageDescriptor>({
      defaultMessage: 'Heavy usage, big win.',
      id: 'off-the-shelve/pricing/option3/description2',
    }),
  },
  insane: {
    key: 'insane',
    min: 2001,
    price: {
      euro: {
        monthly: 66,
        cent: 0.12,
      },
      dollar: {
        monthly: 69,
        cent: 0.13,
      },
    },
    title: defineMessage<MessageDescriptor>({
      defaultMessage: '{currency}{annually} / month + pay for additional use',
      id: 'off-the-shelve/pricing/option4/title',
    }),
    subTitle: defineMessage<MessageDescriptor>({
      defaultMessage: 'billed monthly - cancelable any time',
      id: 'off-the-shelve/pricing/option3/subtitle',
    }),
    name: defineMessage<MessageDescriptor>({
      defaultMessage: 'Expert plus',
      id: 'off-the-shelve/pricing/option4/name',
    }),
    description1: defineMessage<MessageDescriptor>({
      defaultMessage: 'First 2000 triggers: {currency}{annually} / month',
      id: 'off-the-shelve/pricing/option4/description1',
    }),
    description2: defineMessage<MessageDescriptor>({
      defaultMessage: 'From 2000+ triggers: {cent} cent / 5 triggers',
      id: 'off-the-shelve/pricing/option4/description2',
    }),
  },
};
